import { Component } from "react";
import DataLoader, { toLegacyFetcher } from "./../../../../../DataLoader/DataLoader";
import SidePanelSection from "./../../../SidePanelSection/SidePanelSection";
import { Link } from "react-router-dom";
import { fetchLibraryObjects } from "services/content";
import { useTranslation } from "react-i18next";
import {
  buildExerciseSourcePath,
  isExerciseSourceActive,
} from "pages/Exercises/urlState";

export default class SourceSection extends Component {
  render() {
    return (
      <DataLoader fetchData={toLegacyFetcher(fetchLibraryObjects)}>
        <SourceSectionInner {...this.props} />
      </DataLoader>
    );
  }
}

function SourceSectionInner(props) {
  const { t } = useTranslation();

  return (
    <SidePanelSection
      sectionTitle={t("Common.labels.source")}
      list={props.data.list}
      location={props.location}
      tagName={SourceListItem}
    />
  );
}

class SourceListItem extends Component {
  render() {
    const path = buildExerciseSourcePath(this.props.item.id);
    const isActive = isExerciseSourceActive(this.props.location, this.props.item.id);
    return (
      <li className={isActive ? "active" : ""}>
        <Link to={path}>{this.props.item.name}</Link>
      </li>
    );
  }
}
